// Coucou wishlist — localStorage-backed, mirrors Horizon's RecentlyViewed pattern
// (assets/recently-viewed-products.js). No backend, no app. Stores product handles.
//
// Drives, theme-wide:
//   [data-wishlist-toggle="<handle>"]  → toggle button/link (PDP link, gallery heart, card heart)
//   [data-wishlist-count]              → count badge (nav "Love It")
//   [data-coucou-wishlist-grid]        → the /pages/wishlist grid (fetches saved product cards)

(function () {
  'use strict';

  var KEY = 'coucou:wishlist';

  var Wishlist = {
    get: function () {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
    },
    save: function (arr) {
      localStorage.setItem(KEY, JSON.stringify(arr));
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: arr } }));
    },
    has: function (handle) { return this.get().indexOf(String(handle)) !== -1; },
    add: function (handle) {
      var a = this.get();
      if (a.indexOf(String(handle)) === -1) { a.push(String(handle)); this.save(a); }
    },
    remove: function (handle) {
      this.save(this.get().filter(function (h) { return h !== String(handle); }));
    },
    toggle: function (handle) {
      if (this.has(handle)) { this.remove(handle); } else { this.add(handle); }
      return this.has(handle);
    },
    count: function () { return this.get().length; }
  };
  window.CoucouWishlist = Wishlist;

  function syncToggle(el) {
    el.classList.toggle('is-in-wishlist', Wishlist.has(el.dataset.wishlistToggle));
  }

  function bindToggles(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (el) {
      syncToggle(el);
      if (el.dataset.wishlistBound === '1') return;
      el.dataset.wishlistBound = '1';
      el.addEventListener('click', function (e) {
        e.preventDefault();
        Wishlist.toggle(el.dataset.wishlistToggle);
      });
    });
  }
  Wishlist.bindToggles = bindToggles; // expose for async-injected toggles (recs, cards)

  function updateCounts() {
    var n = Wishlist.count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
    });
    // wrappers (e.g. the nav "(n)") hide entirely when empty
    document.querySelectorAll('[data-wishlist-count-wrap]').forEach(function (el) {
      el.hidden = n === 0;
    });
  }

  // --- /pages/wishlist grid -------------------------------------------------
  var wishlistPageLoading = false;

  function initWishlistPage() {
    var grid = document.querySelector('[data-coucou-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-coucou-wishlist-empty]');
    var handles = Wishlist.get();

    function showEmpty() { if (empty) empty.hidden = false; grid.hidden = true; }

    if (!handles.length) { showEmpty(); return; }
    var section = grid.dataset.cardSection;

    wishlistPageLoading = true;
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '?section_id=' + section)
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return null;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          return { handle: h, card: tmp.querySelector('.sm-product') };
        })
        .catch(function () { return null; });
    })).then(function (results) {
      wishlistPageLoading = false;
      // Re-check localStorage — handles removed while loading are not appended
      results.forEach(function (r) {
        if (r && r.card && Wishlist.has(r.handle)) grid.appendChild(r.card);
      });
      bindToggles(grid);
      if (!grid.children.length) {
        showEmpty();
      } else {
        grid.hidden = false;
        if (empty) empty.hidden = true;
      }
    }).catch(function () {
      wishlistPageLoading = false;
      showEmpty();
    });
  }

  function init() {
    bindToggles(document);
    updateCounts();
    initWishlistPage();
  }

  document.addEventListener('wishlist:change', function () {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(syncToggle);
    updateCounts();
    // on the wishlist page, drop any card whose product was just un-liked
    var grid = document.querySelector('[data-coucou-wishlist-grid]');
    if (!grid || wishlistPageLoading) return;
    grid.querySelectorAll('[data-wishlist-toggle]').forEach(function (el) {
      if (!Wishlist.has(el.dataset.wishlistToggle)) {
        var card = el.closest('.sm-product');
        if (card) card.remove();
      }
    });
    var empty = document.querySelector('[data-coucou-wishlist-empty]');
    if (!grid.children.length && empty) { empty.hidden = false; grid.hidden = true; }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
